import http from ":http";

export function requestMetaInfo() {
  return http.get("/api");
}
